const colors = {
  pink: '#FFCAC7',
  redMandy: '#EA5E5E',
  redMojo: '#C6473D',
  orangeCaramel: '#FFD4AF',
  orangeFire: '#E98C31',
  burningOrange: '#FF732C',
  grungeOrange: '#FAA658',
  greenMint: '#AFF3BF',
  greenEmerald: '#34CB6A',
  greenApple: '#44AB46',
  greenMalachite: '#5FD271',
  bluePale: '#B5E6FF',
  blueLight: '#68CDF3',
  blueBright: '#49A2C2',
  pureBlack: '#201F2C',
  pureWhite: '#ffffff',
  pureWhite80: '#ffffff80',
  wildSand: '#f5f5f5',
  alto: '#d8d8d8',
  cornflowerBlue: '#ff8a8a',
  // generic
  grey1: '#888888',
  greyA5: '#A5A5A5',
  grey44: '#444444',
  grey61: '#616161',
  greyCE: '#CECECE',
  greyDD: '#DDDDDD',
  greyD8: '#D8D8D8 ',
  greyD9: '#D9D9D9',
  greyE9: '#E9E9E9',
  grey8b: '#8b8b8b',
  grey82: '#828282',
  grey92: '#929292',
  grey97: '#979797',
  greyF3: '#F3F3F3',
  greyf5: '#f5f5f5',
  greyf0: '#f0f0f0',
  greyAmethyst: '#9592B1',
  greyDisabled: '#A6A5AB',
  // validation
  error: '#C6473D',
  // event
  yellow: '#FFF200',
  lightYellow: '#FFFBAC',
  tuftBlue: '#407CC5',
  duskyBlue: '#3459A2',
  silkBlue: '#5981CF',
  denimBlue: '#7AB1E8',
  // social
  divider: '#b8e7e5',
  footer: '#1F1E2C',
  // family
  familyBlue: '#45A8E2',
  familyLightBlue: '#CDECFC',
  familyYellow: '#FFE887',
  familyBurgundy: '#491313',
  familyGrey: '#F4F4F4',
}

export default colors
